import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
/* --- import Components ----*/
import Layout from 'src/components/Layout';
import { Section } from '../../components/Section';
import { HeroHomeWrapper } from 'src/components/Hero/elements';
import HeroContentLeft from 'src/components/LandingPage/redesign/HeroContentLeft';
import LogoLeReacteurLanding from 'src/components/Logo/LogoLeReacteurLanding';
import WhyLearnCodeSection from 'src/components/LandingPage/redesign/WhyLearnCodeSection';
import WhyJoinSection from 'src/components/LandingPage/redesign/WhyJoinSection';
import StackTechRedesign from 'src/components/LandingPage/redesign/StackTechRedesign';
import TestimonialsSectionLandingPage from 'src/components/LandingPage/TestimonialsSectionLandingPage';
import CtaBottomSection from 'src/components/LandingPage/redesign/CtaBottomSection';
import Star from 'src/components/Icons/Star';
/* --- import Styles ----*/
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

const VisionnerReunionInfoLanding = ({ location }) => {
  return (
    <Layout
      pathname={location.pathname}
      businessType="B2C"
      pageName="Visionner la réunion d'information"
      pageType="landingPage"
      metaTitle="Le Reacteur | Visionnez notre réunion d'information"
      metaDescription="Découvrez notre formation intensive en développement Web et Mobile JavaScript & React. Visionnez notre réunion d'information pour tout savoir sur nos formations certifiantes !"
      css={{ paddingTop: 0 }}
      noFooter
    >
      {/* HERO SECTION */}
      <div
        css={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: colors.purple,
          background: `radial-gradient(ellipse 80% 50% at 50% 100%, rgba(138, 125, 222, 0.6) 0%, ${colors.purple} 60%)`,
        }}
      >
        <Section theme="primary" hero landing css={{ backgroundColor: 'transparent' }}>
          <HeroHomeWrapper
            landing
            css={{
              '& > div:first-child': {
                flex: '1 1 50%',
                maxWidth: '50%',
              },
              '@media only screen and (max-width: 1199px)': {
                flexDirection: 'column',
                alignItems: 'center',
                '& > div:first-child': {
                  flex: '1',
                  maxWidth: '100%',
                },
              },
            }}
          >
            {/* LEFT SIDE */}
            <div
              css={{
                '& > div': {
                  maxWidth: '100%',
                  flex: 'unset',
                },
              }}
            >
              <LogoLeReacteurLanding />
              <HeroContentLeft
                title={
                  <>
                    <span css={{ color: colors.yellow }}>Vidéo de présentation</span> -
                    <br />
                    Devenir Développeur
                  </>
                }
                tagVariant="outlined"
                tags={[{ text: '🎬 Vidéo disponible' }, { text: '💡 Toutes les infos clés' }]}
                subtitle={
                  <strong>Visionnez notre réunion d&apos;information et découvrez :</strong>
                }
                infoBox={
                  <div css={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    <div css={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                      <span css={{ fontSize: 18 }}>✓</span>
                      <span>
                        Nos <strong>formations certifiantes</strong> Code + IA
                      </span>
                    </div>
                    <div css={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                      <span css={{ fontSize: 18 }}>✓</span>
                      <span>
                        Les <strong>programmes les plus complets</strong> du marché
                      </span>
                    </div>
                    <div css={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                      <span css={{ fontSize: 18 }}>✓</span>
                      <span>
                        Les <strong>financements possibles</strong> (CPF, France Travail...)
                      </span>
                    </div>
                  </div>
                }
                checklistItems={[]}
                statsLine1="🎓 +3000 élèves formés"
                statsRating="4,9/5"
                statsRatingLabel="avis vérifiés"
                showLogos={false}
              />

              {/* Évaluations */}
              <div
                css={{
                  height: 80,
                  marginTop: 20,
                  display: 'flex',
                  gap: 30,
                  alignItems: 'center',
                  [mediaQueries.phoneOnly]: {
                    justifyContent: 'center',
                  },
                }}
              >
                <div css={{ height: '100%' }}>
                  <StaticImage
                    src="../../data/images/awards/googlereview.png"
                    alt="logo Google"
                    css={{ height: '85%', aspectRatio: '1/1' }}
                  />
                  <div css={{ display: 'flex', justifyContent: 'center' }}>
                    <Star width="15" height="15" />
                    <Star width="15" height="15" />
                    <Star width="15" height="15" />
                    <Star width="15" height="15" />
                    <Star width="15" height="15" />
                  </div>
                </div>
                <div css={{ height: '100%' }}>
                  <StaticImage
                    src="../../data/images/awards/coursereport.png"
                    alt="logo Course Report"
                    css={{ height: '85%', aspectRatio: '1/1' }}
                  />
                  <div css={{ display: 'flex', justifyContent: 'center' }}>
                    <Star width="15" height="15" />
                    <Star width="15" height="15" />
                    <Star width="15" height="15" />
                    <Star width="15" height="15" />
                    <Star width="15" height="15" />
                  </div>
                </div>
                <div css={{ height: '100%' }}>
                  <StaticImage
                    src="../../data/images/awards/switchup.png"
                    alt="logo SwitchUp"
                    css={{ height: '85%', aspectRatio: '1/1' }}
                  />
                  <div css={{ display: 'flex', justifyContent: 'center' }}>
                    <Star width="15" height="15" />
                    <Star width="15" height="15" />
                    <Star width="15" height="15" />
                    <Star width="15" height="15" />
                    <Star width="15" height="15" />
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE - Vidéo Vimeo */}
            <div
              css={{
                flex: '0 0 48%',
                maxWidth: '48%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignSelf: 'center',
                '@media only screen and (max-width: 1199px)': {
                  width: '100%',
                  maxWidth: '100%',
                  flex: '1',
                  marginTop: '3rem',
                },
                [mediaQueries.phoneOnly]: {
                  width: '100%',
                  maxWidth: '100%',
                  flex: '1',
                  alignSelf: 'stretch',
                  marginTop: '2rem',
                },
              }}
            >
              <div
                css={{
                  backgroundColor: colors.white,
                  borderRadius: 16,
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                }}
              >
                <div
                  css={{
                    padding: '56.25% 0 0 0',
                    position: 'relative',
                  }}
                >
                  <iframe
                    src="https://player.vimeo.com/video/1202178664?h=63cf244d92&badge=0&autopause=0&player_id=0&app_id=58479"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    title="Vidéo de présentation - Le Reacteur"
                    css={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                    }}
                  />
                </div>
                <div
                  css={{
                    padding: '20px 24px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                  }}
                >
                  <StaticImage
                    src="../../data/images/2023_lucas.jpg"
                    alt="Lucas Roberto - Formateur au Reacteur"
                    width={50}
                    height={50}
                    placeholder="none"
                    css={{
                      borderRadius: '50%',
                      flexShrink: 0,
                      border: 'none',
                    }}
                    imgStyle={{ borderRadius: '50%' }}
                  />
                  <p
                    css={{
                      fontSize: '0.85rem',
                      color: colors.black,
                      lineHeight: 1.4,
                      marginBottom: 0,
                    }}
                  >
                    Réunion d&apos;information présentée par <strong>Lucas</strong>, développeur et
                    formateur au Reacteur.
                  </p>
                </div>
              </div>
            </div>
          </HeroHomeWrapper>
        </Section>
      </div>

      {/* POURQUOI APPRENDRE À CODER À L'ÈRE DE L'IA */}
      <WhyLearnCodeSection />

      {/* POURQUOI REJOINDRE LE REACTEUR */}
      <WhyJoinSection historicalCopy />

      {/* TECHNOLOGIES ENSEIGNÉES */}
      <StackTechRedesign theme="secondary" />

      {/* TÉMOIGNAGES */}
      <TestimonialsSectionLandingPage fromPage="reunion" hideButton />

      {/* CTA FINAL */}
      <CtaBottomSection
        onCtaClick={() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
        title="Envie d'en savoir plus ?"
        subtitle="Revisionnez la réunion d'information ou contactez-nous"
        buttonText="Revoir la vidéo ▶️"
        footerText="✓ Gratuit · Sans engagement · Accessible à tout moment"
      />
    </Layout>
  );
};

export default VisionnerReunionInfoLanding;
